// import { DialogErrorComponent } from './../../../../search-book-form/dialog-error/dialog-error.component';
// import { DialogComponent } from './../dialog/dialog.component';
// import { Router } from '@angular/router';
// import { BookService } from './../../../../api/book.service';
// import { Component, Inject, Input, Output, EventEmitter } from '@angular/core';
// import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
// import { MatDatepickerInputEvent } from "@angular/material/datepicker";
// import { BookResult, Book } from 'src/app/models/api_models/book';
// import { MatDialog } from '@angular/material/dialog';



// @Component({
//   selector: 'app-extend',
//   templateUrl: './extend.component.html',
//   styleUrls: ['./extend.component.scss']
// })
// export class ExtendComponent {

//   constructor(public dialog: MatDialog,
//     public dialogRef: MatDialogRef<ExtendComponent>, private bookService: BookService, private router: Router,
//     @Inject(MAT_DIALOG_DATA) public data: BookResult) { }


//   onNoClick(): void {
//     this.dialogRef.close(false);
//   }

//   onConfirm(): void {
//     // Close the dialog, return true
//     this.dialogRef.close(true);
//   }


//   //convert date
//   getDateFormat(str : string){
//    // console.log(str)
//     var newString = str.replace('-','/').replace('-', '/').replace('T',' ').replace(':00Z','');
//    return  newString
//   }


//   //////////// debut   //////////////////////////////////////////////////

//    _start: any = new Date(this.getDateFormat(this.data.startdate))
//    _hourS: string = new Date(this.getDateFormat(this.data.startdate)).getHours().toString();
//    _minS: string = new Date(this.getDateFormat(this.data.startdate)).getMinutes().toString();
  
  

//   //////////////////////////////////////  end  ///////////////////////////////////

//   checkCurrent = false;
//   _extend

//    _end: Date = new Date(this.getDateFormat(this.data.enddate))
//    _hour: string = new Date(this.getDateFormat(this.data.enddate)).getHours().toString();
//    _min: string = new Date(this.getDateFormat(this.data.enddate)).getMinutes().toString();
 



//   //modification date
//   updateDate(type: string, event: MatDatepickerInputEvent<string>) {
//     console.log(event.value);
//     this._end = new Date(event.value);
//     this.checkCurrent = true
//   }

//   //modification heure
//   updateHour(type: string, event) {
//     this._end.setHours(event.value);
//     console.log(event.value);
//     this._hour = event.value.toString();
//     this.checkCurrent = true
//   }

//   //modification minute
//   updateMin(type: string, event) {
//     this._end.setMinutes(event.value);
//     console.log(event.value);
//     this._min = event.value.toString();
//     console.log(this._min );
//     this.checkCurrent = true
//   }


//   public sendConfirm() {
//     if (this._end.getTime() > this._start.getTime()) {


//       let oldEnd : Date = new Date(this.getDateFormat(this.data.enddate))

     
    
//       if (this._end.getTime() > oldEnd.getTime()) {
//         this.bookService.estimeExtendBook(this.data.id, (this._end.getTime() - oldEnd.getTime()) / (1000 * 60)).subscribe(
//           response => {
//             this._extend = response;
//           }
//         );
//       }
//       else
//       {
//         this.openDialogError()
//       }
//     }
//      else
//     {
//        this.openDialogError()
//     }
//   }

//   postExtend() {

//     if (this._end.getTime() > this._start.getTime()) {

//          let oldEnd : Date = new Date(this.getDateFormat(this.data.enddate))
      
//       if (this._end.getTime() > oldEnd.getTime()) {
//         this.bookService.confirmExtendBook(this.data.id, (this._end.getTime() - oldEnd.getTime()) / (1000 * 60)).subscribe(
//           response => {
//             this.dialogRef.close(true);

//             console.log(response);

//             if(!response.id){
//               this.openDialog("Prolongation impossible, le véhicule ou le point de charge est indisponible")
//             }
//             if(response.id){
//               this.openDialog("Merci votre réservation a bien été prolongée")
//             }
            
//             // location.reload()
//             // this.router.navigate([`/auth/reservation/${response.id}`]);
//           }
//         )
//       }
//       else
//       {
//         this.openDialogError()
//       }
//     }
//     else
//     {
//        this.openDialogError()
//     }
//   }


//  // open dialog
//   openDialogError() {
//     this.dialog.open(DialogErrorComponent, {
//       data: 'La date est invalide'
//     });
//   }


  
//   openDialog(msg : string): void {
//     const dialogRef = this.dialog.open(DialogComponent, {
//       // width: '350px',
//       // height: '110px',
//       data: msg
//     });

//     dialogRef.afterClosed().subscribe(result => {
//          location.reload()
//          this.router.navigate([`/auth/reservation/${this.data.id}`]);
//     });
//   }



//   isMamSncf(){
//     if(location.host === 'mam.clem.mobi' || location.host === `www.mam.clem.mobi` ) 
//     {
//       return true
  
//     }else
//     {
//       return false
//     }
//   }


// }






import { DialogErrorComponent } from './../../../../search-book-form/dialog-error/dialog-error.component';
import { DialogComponent } from './../dialog/dialog.component';
import { Router } from '@angular/router';
import { BookService } from './../../../../api/book.service';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { BookResult } from 'src/app/models/api_models/book';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-extend',
  templateUrl: './extend.component.html',
  styleUrls: ['./extend.component.scss']
})
export class ExtendComponent {

  constructor(public dialog: MatDialog,
    public dialogRef: MatDialogRef<ExtendComponent>, private bookService: BookService, private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: BookResult) { }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  // convert date
  getDateFormat(str: string) {
    return str.replace('-', '/').replace('-', '/').replace('T', ' ').replace(':00Z', '');
  }

  //////////// debut //////////////////////////////////////////////////

  _start: any = new Date(this.getDateFormat(this.data.startdate));
  _hourS: string = new Date(this.getDateFormat(this.data.startdate)).getHours().toString();
  _minS: string = new Date(this.getDateFormat(this.data.startdate)).getMinutes().toString();

  //////////// fin ////////////////////////////////////////////////////

  checkCurrent = false;
  _extend;

  _end: Date = new Date(this.getDateFormat(this.data.enddate));
  _hour: string = new Date(this.getDateFormat(this.data.enddate)).getHours().toString();
  _min: string = new Date(this.getDateFormat(this.data.enddate)).getMinutes().toString();

  // modification date : on conserve l'heure et les minutes déjà sélectionnées
  updateDate(type: string, event: MatDatepickerInputEvent<any>) {
    if (!event.value) { return; }
    const d = new Date(event.value);
    d.setHours(Number(this._hour), Number(this._min), 0, 0);
    this._end = d;
    this.checkCurrent = true;
  }

  // modification heure
  updateHour(type: string, event) {
    const d = new Date(this._end);
    d.setHours(Number(event.value));
    this._end = d;
    this._hour = event.value.toString();
    this.checkCurrent = true;
  }

  // modification minute
  updateMin(type: string, event) {
    const d = new Date(this._end);
    d.setMinutes(Number(event.value));
    this._end = d;
    this._min = event.value.toString();
    this.checkCurrent = true;
  }

  public sendConfirm() {
    if (this._end.getTime() > this._start.getTime()) {
      const oldEnd: Date = new Date(this.getDateFormat(this.data.enddate));

      if (this._end.getTime() > oldEnd.getTime()) {
        this.bookService.estimeExtendBook(this.data.id, (this._end.getTime() - oldEnd.getTime()) / (1000 * 60)).subscribe(
          response => {
            this._extend = response;
          }
        );
      } else {
        this.openDialogError();
      }
    } else {
      this.openDialogError();
    }
  }

  postExtend() {
    if (this._end.getTime() > this._start.getTime()) {
      const oldEnd: Date = new Date(this.getDateFormat(this.data.enddate));

      if (this._end.getTime() > oldEnd.getTime()) {
        this.bookService.confirmExtendBook(this.data.id, (this._end.getTime() - oldEnd.getTime()) / (1000 * 60)).subscribe(
          response => {
            this.dialogRef.close(true);

            if (!response.id) {
              this.openDialog('Prolongation impossible, le véhicule ou le point de charge est indisponible');
            }
            if (response.id) {
              this.openDialog('Merci votre réservation a bien été prolongée');
            }
          }
        );
      } else {
        this.openDialogError();
      }
    } else {
      this.openDialogError();
    }
  }

  // open dialog
  openDialogError() {
    this.dialog.open(DialogErrorComponent, {
      data: 'La date est invalide'
    });
  }

  openDialog(msg: string): void {
    const dialogRef = this.dialog.open(DialogComponent, {
      data: msg
    });

    dialogRef.afterClosed().subscribe(() => {
      location.reload();
      this.router.navigate([`/auth/reservation/${this.data.id}`]);
    });
  }

  isMamSncf() {
    return location.host === 'mam.clem.mobi' || location.host === 'www.mam.clem.mobi';
  }
}